import React from "react";
import CampaignGroups from "../../client_config/ppc_config/CampaignGroups"

export default function Social(props) {
  
  const socialCampaignGroups = props.campaignGroups.social
  const allCampaignGroups = props.campaignGroups

  return (
   <div style={{backgroundColor:"#F5F5F5"}}>

    <CampaignGroups {...props} platformType="Social" campaignGroups={socialCampaignGroups} allCampaignGroups={allCampaignGroups} setCampaignGroups={props.setCampaignGroups} onboarding />
   </div>
  
  );
}